import Vue from 'vue'
import Clipboard from 'v-clipboard'
import i18n from './i18n'
import router from './router'
import App from './App'

import { initVerifiedAxios } from './verifiedapi'

Vue.use(Clipboard)
Vue.config.productionTip = false

console.log(process.env.NODE_ENV)

export var AUTH_ENABLED = true
export var SIMBA_SERVICE_BASE_URL
export var AUTH_URL
if (process.env.NODE_ENV === 'production') {
  AUTH_URL = 'https://www.gs1-germany.de'
  SIMBA_SERVICE_BASE_URL = '' // relative route
} else if (process.env.NODE_ENV === 'preproduction') {
  AUTH_URL = 'https://test-10-gs1-germany-de.dev.mehrwert.de'
  SIMBA_SERVICE_BASE_URL = 'https://simba.eecc.de'
} else {
//  AUTH_ENABLED = false
  AUTH_URL = 'https://test-10-gs1-germany-de.dev.mehrwert.de'
  SIMBA_SERVICE_BASE_URL = 'http://localhost:3000'
}
Vue.prototype.$verifiedAPI = initVerifiedAxios(SIMBA_SERVICE_BASE_URL)

const app = {
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<app/>'
}

Object.defineProperty(Vue.prototype, '$locale', {
  get: function () {
    return app.i18n.locale
  },
  set: function (locale) {
    app.i18n.locale = locale
  }
})

/* eslint-disable no-new */
new Vue(app)



// WEBPACK FOOTER //
// ./src/main.js